import { render, staticRenderFns } from "./ProductSelectionSeed.vue?vue&type=template&id=24a3ddbc&lang=html&"
import script from "./ProductSelectionSeed.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionSeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports